import { RESTRICTION_TYPE, RESTRICTION_OPTIONS } from './constants';
import editPageUrl from './edit-page.html';

function includesPersona(list, persona) {
  return list.includes(persona.id) || list.some((elem) => elem.id === persona.id);
}

export default class EditPageCtrl {
  editPageUrl = editPageUrl;

  constructor(
    $state,
    $scope,
    Restangular,
    Authentication,
    Pages,
    Utils,
    PersonaCollection,
    focus,
    page
  ) {
    'ngInject';

    Object.assign(this, {
      $state,
      $scope,
      Restangular,
      Authentication,
      Pages,
      Utils,
      PersonaCollection,
      focus,
      page,
    });
  }

  toggle = () =>
    (this.restrictToSelectedUsers =
      Array.isArray(this.page.restricted) ||
      this.page.restricted === RESTRICTION_TYPE.SELECTED_ONLY);

  get restrictionType() {
    return Array.isArray(this.page.restricted)
      ? RESTRICTION_TYPE.SELECTED_ONLY
      : this.page.restricted || RESTRICTION_TYPE.NONE;
  }

  set restrictionType(value) {
    this.page.restricted = value;
    this.toggle();
  }

  get nameError() {
    return this.form.$submitted && this.form.$invalid;
  }

  get hasEveryoneGroup() {
    return !!this.page.personas.find((p) => p.id === this.PersonaCollection.everyone.id);
  }

  get nameErrorMsg() {
    if (this.form.name?.$error.required) {
      return 'Please specify name of your page';
    }
    if (this.form.name?.$error.maxlength) {
      return 'Please limit the page name to 50 characters';
    }
    return '';
  }

  updatePageUsers = () => {
    this.pageUsers = this.PersonaCollection.unwrapUsers(this.page.personas);
  };

  $onInit() {
    this.focus('focus');
    this.personas = this.PersonaCollection.canSeeOtherLocations
      ? this.PersonaCollection.personas
      : this.PersonaCollection.visibleUsers;
    this.availableUsers = this.PersonaCollection.visibleUsers;
    this.updatePageUsers();

    if (this.page.id) {
      this.page = {
        ...this.page,
        restrictedToPersonas: this.page.restrictedToPersonas.map((id) => ({ id })),
      };
      this.pageOwner = this.page.owner;

      if (this.page.open && !this.hasEveryoneGroup) {
        this.page.personas.push({ id: this.PersonaCollection.everyone.id });
      }
    } else {
      this.pageOwner = this.Authentication.user;
      this.page.personas = [];
    }

    if (!this.page.restrictedToPersonas) {
      this.page.restrictedToPersonas = [];
    }

    if (!includesPersona(this.page.restrictedToPersonas, this.pageOwner)) {
      this.page.restrictedToPersonas.push(this.pageOwner);
    }

    this.nonDeletableMembers = [this.pageOwner.id];

    this.fromManage = this.$state.current.name.includes('dashboard');
    this.isManager = this.Authentication.user.isManager;
    this.isPremium = this.Authentication.user.org.isPremium;

    this.restrictionOptions = RESTRICTION_OPTIONS;

    if (!this.page.restricted) {
      this.page.restricted = RESTRICTION_TYPE.NONE;
    }

    this.toggle();
  }

  async save(form) {
    if (form.$invalid) {
      form.$setSubmitted();
      throw new Error('Form invalid');
    }

    this.error = false;

    let promise;
    const pageId = this.page.id;

    const page = this.getPageShallowCopy(this.page);
    page.restrictedToPersonas = page.restrictedToPersonas.map(({ id }) => id);

    if (!page.personas.find((u) => u.id === this.pageOwner.id)) {
      page.personas.push({ id: this.pageOwner.id });
    }

    page.open = this.hasEveryoneGroup;

    if (pageId) {
      promise = page
        .withHttpConfig({ ignoreGlobalErrorHandler: true })
        .put({ 'user-fields': 'id' });
    } else {
      promise = this.Pages.withHttpConfig({ ignoreGlobalErrorHandler: true }).post(page, {
        'user-fields': 'id',
      });
    }

    try {
      const data = await promise;
      if (this.fromManage) {
        this.$state.go('dashboard.manage.pages');
      } else {
        this.$state.go('newsfeed.view.page', { pageId: data.id }, { reload: true });
      }
    } catch (error) {
      if (error && error.status !== 502) {
        this.error = this.Utils.getErrorMessages(error);
      }
      throw error;
    }
  }

  getPageShallowCopy(originalPage) {
    const SHALLOW_COPY_PROPS = [
      'members',
      'subscribers',
      'restrictedToPersonas',
      'articles',
      'personas',
    ];
    let pageCopy = {};
    Object.keys(originalPage).forEach((key) => {
      if (key === 'owner') {
        pageCopy[key] = { id: originalPage.owner.id };
      } else if (SHALLOW_COPY_PROPS.includes(key)) {
        pageCopy[key] = [];
      } else {
        pageCopy[key] = originalPage[key];
      }
    });

    pageCopy = this.Restangular.copy(pageCopy);

    const copyFn = (p) => ({ id: p.id });
    SHALLOW_COPY_PROPS.forEach((key) => {
      pageCopy[key] = (originalPage[key] || []).map(copyFn);
    });

    return pageCopy;
  }

  cancel() {
    if (this.fromManage) {
      this.$state.go('dashboard.manage.pages');
    } else if (this.page.id) {
      this.$state.go('newsfeed.view.page', { pageId: this.page.id });
    } else {
      this.$state.go('newsfeed.view.mynewsfeed');
    }
  }
}
